const getMetaTag = (name: string): string => {
  const foundMeta = document.querySelector(`meta[name="${name}"]`);
  const data = foundMeta ? foundMeta.getAttribute('content') : process.env[name];
  return data || '';
};

/* eslint-disable import/no-mutable-exports */
let API_URL = getMetaTag('API_URL') || 'http://localhost:3004';
let FEDERATION_GATEWAY_URL = getMetaTag('FEDERATION_GATEWAY_URL');
// NOTE: Uses SL-gateway's auth-cage in order to sync PUI's one
let SHORTLYSTER_URL = getMetaTag('SHORTLYSTER_URL') || 'http://localhost:3000';
const AUTH_GATEWAY_DOMAIN = getMetaTag('AUTH_GATEWAY_DOMAIN') || 'auth.dev.platform.compono.dev';
const AUTH_GATEWAY_OIDC_ISSUER =
  getMetaTag('AUTH_GATEWAY_OIDC_ISSUER') || 'https://auth.dev.platform.compono.dev/';
const AUTH_CLIENT_ID = getMetaTag('AUTH_CLIENT_ID') || 'auth0';

/* eslint-enable import/no-mutable-exports */

const {
  location: { hostname },
} = document;

// when running in acceptar and need to change localhost -> dockerhost
if (API_URL && API_URL.endsWith('localhost:3004') && !API_URL.includes(hostname)) {
  API_URL = API_URL.replace('localhost:', `${hostname}:`);
  SHORTLYSTER_URL = SHORTLYSTER_URL.replace('localhost:', `${hostname}:`);
}

const HEADLESS_TESTING = navigator.userAgent.includes(' HeadlessChrome/');

export {
  API_URL,
  FEDERATION_GATEWAY_URL,
  HEADLESS_TESTING,
  SHORTLYSTER_URL,
  AUTH_GATEWAY_DOMAIN,
  AUTH_GATEWAY_OIDC_ISSUER,
  AUTH_CLIENT_ID,
};
